import { LayerType } from '../enums/LayerType';
import { Point } from '../Point';

export interface MachineRasterMessage {
  Base64EncodedLayer: string;
  NorthEast: Point;
  SouthWest: Point;
  GridX: number;
  GridY: number;
  TimeStamp: number;
  Type: LayerType;
  MachineKey: string;
  JobID: string;
}

// Converts JSON strings to/from your types
export class ConvertMachineRasterMessage {
  public static stringToMachineRasterMessage(json: string): MachineRasterMessage {
    return JSON.parse(json);
  }
}
